var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgColors = function SvgColors(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.076 16.963-5.38-5.382a1.49 1.49 0 0 1-.329-.48 1.408 1.408 0 0 1 0-1.095c.073-.175.183-.335.329-.48l5.031-5.01L3.41 2.198 4.765.776l8.75 8.75c.145.147.25.307.316.482s.099.358.099.547c0 .19-.033.372-.099.547a1.349 1.349 0 0 1-.317.481l-5.382 5.38a1.489 1.489 0 0 1-.481.329 1.409 1.409 0 0 1-1.094 0 1.487 1.487 0 0 1-.481-.329Zm1.03-11.068-4.682 4.68 9.362.002-4.68-4.682Zm8.726 11.507c-.525 0-.97-.186-1.334-.558a1.878 1.878 0 0 1-.547-1.367c0-.394.099-.766.295-1.116.197-.35.42-.692.668-1.028l.919-1.18.962 1.18c.233.336.452.679.656 1.029.204.35.306.722.306 1.115 0 .54-.19.996-.569 1.368a1.87 1.87 0 0 1-1.356.557Z",
    fill: "currentColor"
  })));
};
export default SvgColors;